import { Circles } from 'react-loading-icons';
import React from 'react';

const Header = ({ content }) => {
  if (!content || !content.data) {
    return (
      <div className="grid place-items-center h-40">
        <Circles className="w-8 h-8 text-gray-500" />
      </div>
    );
  }

  const { data, released, tags } = content;
  const { contentName, contentDescription } = data;

  return (
    <div className="flex flex-col lg:flex-row items-center  justify-center gap-8 p-4 sm:p-6 md:p-10 max-w-screen-xl mx-auto">
      <div className="grid gap-y-4 text-center">
        <h2 className="text-white font-bold text-4xl sm:text-5xl font-hind text-center pt-6 lg:pt-0">
          {contentName || 'Untitled'}
        </h2>
        <h3 className="text-faded font-hind text-sm sm:text-lg text-center px-10 sm:px-20">
          {contentDescription || 'No description available.'}
        </h3>

        {tags?.length > 0 && (
          <div className="flex gap-x-6 justify-center overflow-hidden flex-wrap">
            {tags.map((genre, index) => (
              <div
                key={index}
                className="rounded-3xl flex items-center text-sm font-hind text-faded p-3 bg-blue-950 whitespace-nowrap"
              >
                {genre.name}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
